const wordList = () => import('@/pages/product/word/index.vue');

export default [{
    path: '/product/word',
    component: wordList,
    meta: [{
        name: '产品管理',
		activeRoute: '/product/manage'
    },
    {
        name: '敏感词列表',
        activeRoute: '/product/word'
    }]
}];